// Issues table pagination — page navigation with item count
import { Button } from '@/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface IssuesTablePaginationProps {
  page: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
}

export function IssuesTablePagination({
  page, pageSize, total, onPageChange,
}: IssuesTablePaginationProps): JSX.Element {
  const totalPages = Math.ceil(total / pageSize)
  const from = page * pageSize + 1
  const to = Math.min((page + 1) * pageSize, total)

  if (total === 0) return <></>

  return (
    <div className="flex items-center justify-between border-t px-4 py-3">
      <p className="text-sm text-kaycoo-charcoal-2">
        Showing <span className="font-medium">{from}</span>–<span className="font-medium">{to}</span> of{' '}
        <span className="font-medium">{total}</span> issues
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 0}
          className="h-8"
        >
          <ChevronLeft className="mr-1 h-4 w-4" /> Previous
        </Button>
        <span className="text-sm text-kaycoo-charcoal-2">
          Page {page + 1} of {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages - 1}
          className="h-8"
        >
          Next <ChevronRight className="ml-1 h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
